import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data";

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-28 md:py-36" data-testid="testimonials">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-3xl mb-16"
        >
          <span className="text-primary text-sm font-semibold tracking-[0.25em] uppercase">Trusted by builders</span>
          <h2 className="mt-4 font-heading font-light tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-foreground">
            The proof is in<br />the rework they avoided.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative rounded-2xl border border-white/10 bg-card p-8 flex flex-col hover:border-primary/40 transition-colors duration-300"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="text-primary mb-6" size={30} />
              <blockquote className="text-base md:text-lg text-foreground/90 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="font-heading font-semibold text-foreground">{t.name}</div>
                <div className="text-sm text-muted-foreground">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
